/*eslint new-cap:0 */
/*eslint no-useless-escape:0 */
import _ from 'underscore';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

const s$Keyword = window.globalLegacySchema.get('Keyword');

export const parseKeyword = (text) => {
  let matchType = '';
  let keyword = text;

  if (/^".*"$/.test(text)) {
    keyword = text.replace(/\"/g, '');
    matchType = 'Phrase';
  } else if (/^\[.*\]$/.test(text)) {
    keyword = text.replace(/(\[|\])/g, '');
    matchType = 'Exact';
  } else {
    matchType = 'Broad';
  }

  return {
    Text: keyword,
    MatchType: matchType,
  };
};

export class ViewModel {
  constructor(options = {}) {
    this.properties = _.keys(s$Keyword.properties);

    koSchema.properties(this, s$Keyword, this.properties);

    if (_.isEmpty(options.properties)) {
      const parsedKeyword = parseKeyword(options.text);

      this.Text(parsedKeyword.Text);
      this.MatchType(parsedKeyword.MatchType);

      this.AdGroup({ Id: options.adGroup.Id });
      this.AdGroupName(options.adGroup.Name);

      const campaign = options.context ? options.context.get('Campaign') : { };

      this.Campaign({ 'Id': campaign.Id });
      this.CampaignName(campaign.Name);
    } else {
      _.each(options.properties, (value, key) => {
        if (_.indexOf(this.properties, key) !== -1) {
          this[key](value);
        }
      });
    }
  }
}

